import { fetchDataByTag as fetchDataByTagApi } from 'support/api/DataByTagApi';
import { HttpClient } from 'support/api/api-types';

export const MARKET = 'MARKET' as const;
export const CLEAR_MARKET = 'CLEAR_MARKET' as const;

export const fetchMarket = (tag: string) => ({
  type: MARKET,
  promise: (httpClient: HttpClient) => fetchDataByTagApi(httpClient, tag),
  meta: {
    id: tag,
  },
});

export const clearMarket = () => ({
  type: CLEAR_MARKET,
});
